import BaseAPI from '@/apis/base/baseApi';

class UserLogAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'UserLog';
}

export default new UserLogAPI();
